
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><strong parentName="p">{`Tous ces «contacts proches» enregistrés par l'application`}</strong>{` reçoivent une
alerte – même ceux que vous ne connaissez pas personnellement. Chaque contact
reçoit un message lui demandant de joindre une hotline de la Confédération et de
se mettre ensuite en quarantaine. La chaîne des infections est ainsi rompue.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;